import { createFileRoute, useSearch } from '@tanstack/react-router'
import { CriteriaView } from '../../../components/group-steering/ResourcesViews'

export const Route = createFileRoute('/$org/group/criteria')({
    component: CriteriaRoute,
})

function CriteriaRoute() {
    const { org } = Route.useParams()
    const search = useSearch({ from: '/$org/group' })
    return <CriteriaView org={org} period={search.period ?? '90d'} level={search.level ?? 'agency'} />
}
